import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-empty-state",
  templateUrl: "./empty-state.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  @Input({ required: true }) titleKey!: string;
  @Input() descriptionKey?: string;
  @Input() actionLabelKey?: string;
  @Input() actionIcon: string = "add";
  /** Drop the 60vh min-height in favour of compact vertical padding, for placement inside a card/panel. */
  @Input() compact: boolean = false;
  @Output() action = new EventEmitter<void>();

  readonly onActionClick = () => this.action.emit();
}
